function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "42",
  height: "25",
  viewBox: "0 0 42 25",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Meldedialog",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Meldung-Einzelansicht",
  transform: "translate(-301 -325)",
  stroke: "#999",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(294 308)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(8 18)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.026 23.784V8.636s-.666-3.88 4.763-3.88h23.487c4.178 0 3.708 3.88 3.708 3.88v15.148",
  id: "Path-12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.026 19.027V3.879S7.36 0 12.789 0h23.487c4.178 0 3.708 3.88 3.708 3.88v15.147",
  id: "Path-12-Copy"
})))))));